import { useEffect, useState } from "react";
import PageTemplate from "../components/templates/PageTemplate";
import IrDocList from "../components/ir/IrDocList";
import FilterIRByPublishedYear from "../components/ir/FilterIRByPublishedYear";
import { useGetAllIRDocs } from "../api/DocsApi";
import { IRDoc } from "../models/Doc";
import { orderBy } from "natural-orderby";
import { IrPageLayout } from "@/components/ir/IrPageLayout";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";

const Ir = () => {
  const { data } = useGetAllIRDocs();
  const [year, setYear] = useState<string | null>(null);
  const filteredData = (): IRDoc[] => {
    if (data) {
      if (year) {
        return data?.filter((ir) => {
          const publishedYear = Object.keys(ir.categories)[0];
          return year === "전체보기" ? true : year === publishedYear;
        });
      }
      return sortIR(data);
    }
    return [];
  };

  const sortIR = (data: IRDoc[]) => {
    return orderBy(data, [(v) => Object.keys(v.tags)[0]], ["desc"]);
  };

  useEffect(() => {
    collectFilterableYears();
  }, []);

  const collectFilterableYears = () => {
    let filterableYears: string[] = [];
    if (data) {
      data.forEach((ir) => {
        const publishedYear = Object.keys(ir.categories)[0];
        if (
          !filterableYears.includes(publishedYear) &&
          !isNaN(parseInt(publishedYear))
        ) {
          filterableYears.push(publishedYear);
        }
      });
    }
    return filterableYears;
  };

  return (
    <PageTemplate>
      <PageTemplate.Content>
        <IrPageLayout>
          <div className={"flex flex-col px-5 pt-7.5 md:flex-row md:pt-0"}>
            <div
              className={
                "md:max-w-1/3 flex w-full max-w-[378px] justify-between md:mt-5 md:flex-col md:items-start md:justify-start lg:max-w-full"
              }
            >
              <div
                className={
                  "text-1.5xl mt-3 block font-700 leading-tight md:mt-0 md:text-2xl lg:text-3xl"
                }
              >
                {"투자자 정보"}
              </div>
              <span
                className={"mt-2.5 hidden h-px w-full bg-[#222222] md:block"}
              />
              <p className={"mb-10 mt-8 block text-lg leading-tight"}>
                {"전자공고"}
              </p>
            </div>
            <div
              className={"flex w-full max-w-[786px] flex-col pb-10 md:ml-7.5"}
            >
              <div className={"flex w-full place-content-end items-end py-3"}>
                <FilterIRByPublishedYear
                  filterableYears={collectFilterableYears()}
                  onFilter={(year) => {
                    setYear(year);
                  }}
                />
              </div>
              <IrDocList filteredData={filteredData()} />
            </div>
          </div>
        </IrPageLayout>
      </PageTemplate.Content>
    </PageTemplate>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["gnb"])),
    },
  };
}

export default Ir;
